import React from 'react';
import PlayerBonusToggle from '../PlayerBonusToggle/PlayerBonusToggle';
import {getNextLobbyBonusType} from '../../utils/lobby/lobbyBonus';

export const TEXT_LOBBY_BONUS_CREATOR_TOOLTIP = 'Бонус всем игрокам лобби:\nувеличивает стартовые монеты, доход монет (у старших уровней — и за каждый город) и действия в фазе Строительства.';
export const TEXT_LOBBY_BONUS_MEMBER_TOOLTIP = 'Бонус всем игрокам лобби, выбирает создатель лобби:\nувеличивает стартовые монеты, доход монет (у старших уровней — и за каждый город) и действия в фазе Строительства.';

/**
 * Бонус обычного сетевого лобби (см. utils/lobby/lobbyBonus): один уровень на
 * всех игроков. Создатель переключает уровень по кругу (onSelect получает
 * следующий), остальные участники только видят выбранный — он действует и на
 * них.
 */
const LobbyBonusToggle = ({bonusType, isCreator, onSelect}) => (
  <PlayerBonusToggle
    bonus={bonusType}
    onCycle={isCreator ? () => onSelect(getNextLobbyBonusType(bonusType)) : undefined}
    tooltipText={isCreator ? TEXT_LOBBY_BONUS_CREATOR_TOOLTIP : TEXT_LOBBY_BONUS_MEMBER_TOOLTIP}
    className="lobby-bonus-toggle"
  />
);

export default LobbyBonusToggle;
